import React, { useState, forwardRef, useMemo } from 'react';
import {
    FormControl,
    Select,
    MenuItem,
    ListItemText,
    Typography,
    ListSubheader,
    TextField,
    InputAdornment,
    InputLabel
} from '@mui/material';
import { getAllEmployees } from 'src/services/employeeService';
import SearchIcon from '@mui/icons-material/Search';
import '../Feedback.css';

interface employeeDropdownProps {
    value: string;
    onChange: (e: any) => void;
    disabled?: boolean;
    required?: boolean;
    label?: string;
    getEmp: (e: any) => void;
}

const EmployeeSelectDropdown = forwardRef((props: employeeDropdownProps, _ref) => {
    const [list, setList] = useState([]);
    const [searchText, setSearchText] = useState<string>('');

    const fetchEmployees = (searchText) => {
        getAllEmployees().then((res) => {
            let sortedData = res.data.filter(e => !e?.employeeFinance?.isResign).sort((a, b) =>
                b.createdOn.localeCompare(a.createdOn));
            setList(sortedData?.filter((option) => containsText(option?.name, searchText)));
        });
    }

    const containsText = (text, searchText) =>
        text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;


    React.useEffect(() => {
        fetchEmployees(searchText);
    }, []);

    const filteredLists = useMemo(
        () =>
            list.length > 0 &&
            list?.filter((option) => containsText(option?.name, searchText)),
        [list, searchText]
    );

    const handleSelectionChange = (e: any) => {
        const selectedId = e.target.value;
        const selectedEmployee = list.find((employee) => employee.employeeId === selectedId);
        props.getEmp(selectedEmployee)
    };

    return (
        <FormControl
            fullWidth
            disabled={props?.disabled ? props?.disabled : false}
            className="task-type-dropdown"
        >
            {props?.label && (<InputLabel
                style={{
                    fontSize: '12px'
                }}
            >
                {props?.label}
            </InputLabel>)}

            <Select
                sx={{ mt: '4px' }}
                style={{
                    fontSize: '12px',
                    height: '2rem',
                    marginTop: '8px'
                }}
                displayEmpty
                size="small"
                value={props?.value ? props?.value : ""}
                onChange={(e) => { props?.onChange(e);handleSelectionChange(e) }
                }
            >
                {!props?.label && (<MenuItem style={{ display: 'none' }} selected disabled value={''}>
                    Select Resource
                </MenuItem>
                )}
                <ListSubheader>
                    <TextField
                        id="employee-id"
                        size="small"
                        autoFocus
                        placeholder="Type to search..."
                        fullWidth
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            )
                        }}
                        onChange={(e) => setSearchText(e.target.value)}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                        onKeyDown={(e) => {
                            if (e.key !== 'Escape') {
                                e.stopPropagation();
                            }
                        }}
                    ></TextField>
                </ListSubheader>
                {filteredLists?.length > 0 &&
                    filteredLists.map((type, i) => {
                        return (
                            <MenuItem key={i} value={type.employeeId}>
                                <ListItemText primary={type.name} />
                            </MenuItem>
                        );
                    })}
            </Select>
        </FormControl>
    );
});

export default EmployeeSelectDropdown;
